const MenuItems = [{
  id: 1,
  itemId: "buger01",
  name: "Rice",
  imgSrc: "/images/img1.jpg",
},
{
  id: 2,
  itemId: "pizza01",
  name: "Swallow",
  imgSrc: "/images/swallow/img3.jpg",
},
{
  id: 3,
  itemId: "hotdog01",
  name: "Snacks",
  imgSrc: "/images/snacks/sausage.jpg",
},

{
  id: 4,
  itemId: "drink01",
  name: "Drink",
  imgSrc: "/images/drinks/maltina.jpg",
},
];

const Items = [{
  id: 1,
  itemId: "buger01",
  imgSrc: "/images/img1.jpg",
  name: "Ofada Rice",
  ratings: 5,
  price: "1200",
},
{
  id: 2,
  itemId: "buger01",
  imgSrc: "/images/img2.jpg",
  name: "Jollof Rice",
  ratings: 5,
  price: "750",
},
{
  id: 3,
  itemId: "buger01",
  imgSrc: "/images/img3.jpg",
  name: "White rice and stew",
  ratings: 3,
  price: "500",
},
{
  id: 4,
  itemId: "buger01",
  imgSrc: "/images/img4.jpg",
  name: "Fried rice",
  ratings: 5,
  price: "950",
},
{
  id: 5,
  itemId: "pizza01",
  imgSrc: "/images/swallow/img1.jpg",
  name: "Eba and Egusi",
  ratings: 5,
  price: "750",
},
{
  id: 6,
  itemId: "pizza01",
  imgSrc: "/images/swallow/img2.jpg",
  name: "Eba and banga",
  ratings: 4,
  price: "1200",
},
{
  id: 7,
  itemId: "pizza01",
  imgSrc: "/images/swallow/img3.jpg",
  name: "Amala and Ewedu",
  ratings: 5,
  price: "500",
},
{
  id: 8,
  itemId: "pizza01",
  imgSrc: "/images/swallow/img4.jpg",
  name: "Pounded yam and Egusi",
  ratings: 4,
  price: "1500",
},
{
  id: 9,
  itemId: "hotdog01",
  imgSrc: "/images/snacks/sausage.jpg",
  name: "Sausage roll",
  ratings: 4,
  price: "700",
},
{
  id: 10,
  itemId: "hotdog01",
  imgSrc: "/images/snacks/eggroll.jpg",
  name: "Egg rolls",
  ratings: 3,
  price: "1000",
},
{
  id: 11,
  itemId: "drink01",
  imgSrc: "/images/drinks/Coke.jpg",
  name: "Coca-cola",
  ratings: 5,
  price: "200",
},
{
  id: 12,
  itemId: "drink01",
  imgSrc: "/images/drinks/fanta.jpg",
  name: "Fanta",
  ratings: 5,
  price: "200",
},
{
  id: 13,
  itemId: "drink01",
  imgSrc: "/images/drinks/maltina.jpg",
  name: "Maltina",
  ratings: 5,
  price: "300",
},
{
  id: 14,
  itemId: "drink01",
  imgSrc: "/images/drinks/smoov.jpg",
  name: "Smoov",
  ratings: 5,
  price: "200",
},

];

export { MenuItems, Items };